import { createNodeDef } from "../../nodes.helpers";
import { DataFieldType } from "src/types/data-field.types";
import { randRgb } from "@ngneat/falso";

export const randRgbNodeDef = createNodeDef({
  type: "randRgb",
  displayName: "RGB Color",
  defaultName: "rgb",
  fields: [{ type: DataFieldType.BOOLEAN, key: "alpha", label: "Alpha" }],
  initialData: () => ({ alpha: false }),
  generate: ({ node }) => {
    return randRgb({ alpha: node.data.alpha });
  },
});
